import { render, staticRenderFns } from "./lahi-technical-error.vue?vue&type=template&id=2ea5f4ba&lang=pug"
import script from "./lahi-technical-error.vue?vue&type=script&lang=js"
export * from "./lahi-technical-error.vue?vue&type=script&lang=js"
import style0 from "./lahi-technical-error.vue?vue&type=style&index=0&id=2ea5f4ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports